// Strictly typed TrackStatusPage.tsx
import React, { FC } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm, InjectedFormProps } from 'redux-form'
import { FormButtons, renderers, validations } from '../../components'

interface CustomerLoginFormData {
  contact_number: string
}

const CustomerLoginForm: FC<InjectedFormProps<CustomerLoginFormData>> = ({ handleSubmit, pristine, reset, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="contact_number"
        type="text"
        component={renderers.renderField}
        validate={[validations.required, validations.contactNumber]}
      />
      <ReactBootstrap.Col xs={12} sm={12} style={{ marginLeft: '8px' }} className="pl-0">
        <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
      </ReactBootstrap.Col>
    </form>
  )
}

export default reduxForm<CustomerLoginFormData>({
  form: 'CustomerLoginForm',
})(CustomerLoginForm)

// Rema
